import { render, staticRenderFns } from "./ProductLrModule.vue?vue&type=template&id=0f06c2fe&scoped=true"
import script from "./ProductLrModule.vue?vue&type=script&lang=js"
export * from "./ProductLrModule.vue?vue&type=script&lang=js"
import style0 from "./ProductLrModule.vue?vue&type=style&index=0&id=0f06c2fe&prod&lang=scss&scoped=true"
import style1 from "./ProductLrModule.vue?vue&type=style&index=1&id=0f06c2fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f06c2fe",
  null
  
)

export default component.exports